export const pages = {
	'main': { id: 'main', page: 'main', getter: () => import(/* webpackChunkName: 'main' */ 'components/bolt/main/main') }
};
export const sections = [

];
